import { Cancel, Close, Save } from "@mui/icons-material";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle
} from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../api2";
import Helper from "../../helpers";
import { commonReducerSelector, userSelector } from "../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";
import MapVungTrong from "./mapVungTrong";

const RoutesLoHang = [
  {
    path: "",
    main: () => <LoHang />
  },
  {
    path: "add",
    main: () => <HandleLoHang />
  },
  {
    path: "edit/:id",
    main: () => <HandleLoHang />
  }
];
export default RoutesLoHang;

function LoHang() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [dataQrBase64, setDataQrBase64] = useState(null);
  const [vungSanXuatIds, setVungSanXuatIds] = useState([]);
  const formikRef = useRef();
  const printRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListLoHang({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      {
        headerName: "Tên lô hàng",
        field: "tenLoHang",
        width: "350px"
      },
      {
        headerName: "Ngày xuất bán",
        field: "ngayXuatBan",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRenderer: prams => {
          return (
            <div>{Helper.formatDate(prams?.data?.ngayXuatBan * 1000)}</div>
          );
        }
      },
      {
        headerName: "Hạn sử dụng",
        field: "hanSuDung",
        width: "200px"
      },
      { headerName: "Sản lượng", field: "sanLuong", minWidth: 200, flex: 1 },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            handleShowQr={handleShowQr}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteLoHangById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  const handleShowQr = params => {
    new Api()
      .GetQrLoHangById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          setDataQrBase64(res?.data?.qrImage);
          setOpen(params?.tenLoHang);
        } else {
          ThongBao({ status: "error", message: "Lỗi sinh mã QR" });
        }
      })
      .catch(err => {});

    // danh sách lô hàng không trả về vungSanXuatIds nên phải lấy từ bản ghi chi
    // tiết; lỗi ở đây chỉ làm mất bản đồ, không được chặn việc hiện mã QR
    setVungSanXuatIds([]);
    new Api()
      .GetLoHangById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          setVungSanXuatIds(res?.data?.vungSanXuatIds || []);
        }
      })
      .catch(err => {});
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const printWindow = window.open("", "", "");
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>In QR Code</title>
        </head>
        <body onload="window.print(); window.close();">
          ${content}
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs title={[{ name: "Vận hành" }, { name: "Lô hàng" }]} />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div ref={printRef}>
          <div
            style={{
              textAlign: "center",
              fontSize: 25,
              fontWeight: 800,
              margin: "10px 0px 6px 0px"
            }}
          >
            QR CODE
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: 18,
              fontWeight: 600,
              margin: "0px 6px 0px 6px"
            }}
          >
            Tên lô hàng: {open}
          </div>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <img
              style={{ width: 300, height: 300 }}
              src={`data:image/png;base64,${dataQrBase64}`}
              alt="QR Code"
            />
          </div>
        </div>
        {/* để ngoài printRef vì hàm in copy innerHTML, bản đồ leaflet in ra sẽ vỡ */}
        <div style={{ padding: "0px 24px 16px 24px" }}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              margin: "4px 0px 8px 0px",
              color: "#181818cf"
            }}
          >
            BẢN ĐỒ VÙNG TRỒNG
          </div>
          {open && <MapVungTrong vungSanXuatIds={vungSanXuatIds} />}
        </div>
        <DialogActions
          className="capPhep-listInput-dialog-content"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <MyButton
            onClick={() => setOpen(false)}
            txt="Hủy bỏ"
            color="rgb(124, 124, 124)"
            className="capPhep-listInput-dialog-buttonClose"
            icon={<Close />}
          />
          <MyButton
            // onClick={() => {
            //   // arrayHelpers.remove(alert);
            //   // setAlert(false);
            // }}
            onClick={handlePrint}
            txt="In QR-Code"
            className="capPhep-listInput-dialog-buttonCheck"
            // icon={<Check />}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}

function HandleLoHang() {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile;
  const dataDanhMuc = common?.danhmucs?.data;
  const [sanPhamList, setSanPhamList] = useState(null);
  const [vungSanXuatList, setVungSanXuatList] = useState(null);
  const [coSoSanXuatList, setCoSoSanXuatList] = useState(null);
  const [coSoCheBienList, setCoSoCheBienList] = useState(null);
  const [coSoPhanPhoiList, setCoSoPhanPhoiList] = useState(null);

  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetLoHangById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(sanPhamList)) {
      new Api().GetListSanPhamOfLoHang().then(data => {
        if (data.code === 200) {
          setSanPhamList(data?.data);
        }
      });
    }
    if (isEmpty(vungSanXuatList)) {
      new Api().GetListVungSanXuat().then(data => {
        if (data.code === 200) {
          setVungSanXuatList(data?.data?.records);
        }
      });
    }
    if (isEmpty(coSoSanXuatList)) {
      new Api().GetListCoSoSanXuatOfLoHang().then(data => {
        if (data.code === 200) {
          setCoSoSanXuatList(data?.data);
        }
      });
    }
    if (isEmpty(coSoCheBienList)) {
      new Api().GetListCoSoCheBienOfLoHang().then(data => {
        if (data.code === 200) {
          setCoSoCheBienList(data?.data);
        }
      });
    }
    if (isEmpty(coSoPhanPhoiList)) {
      new Api().GetListCoSoPhanPhoiOfLoHang().then(data => {
        if (data.code === 200) {
          setCoSoPhanPhoiList(data?.data);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(
    data,
    sanPhamList,
    vungSanXuatList,
    coSoCheBienList,
    coSoPhanPhoiList,
    coSoSanXuatList
  );

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            sanPhamList={sanPhamList}
            vungSanXuatList={vungSanXuatList}
            coSoCheBienList={coSoCheBienList}
            coSoPhanPhoiList={coSoPhanPhoiList}
            coSoSanXuatList={coSoSanXuatList}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertLoHang({
        token: user.access_token,
        data: parseDataSave(formRef.current.values, profile)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Vận hành" },
            { name: "Lô hàng", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            handleSave();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
